const getBlockImageAlt = (imageField) => {
  if (typeof imageField === "string")
    return "";
  if (!imageField.src)
    return "";
  return imageField.alt;
};
export default getBlockImageAlt;
